import * as React from "react";
import { Formik, FormikHelpers, Form, Field } from "formik";

import ErrorMessage, { FormContainer, FormContainerWrapper, RootContainer } from "./components";

import Api from "@services/Api";
import Auth from "@services/Auth";
import { Navigate, useNavigate } from "react-router";
import { Link } from "react-router-dom";
import LogRocket from "logrocket";
import ReactGA from "react-ga4";
import { RootState, useAppDispatch } from "@services/Redux";
import { useSelector } from "react-redux";

import { fetchCompany } from "@services/Redux/company";
import FormikTextInput from "@components/FormikTextInput";
import MetaPixel from "@utils/meta/MetaPixel";
interface RegisterFormValues {
  name: string;
  email: string;
  phone: string;
  password: string;
  repassword: string;
}

const RegisterScreen: React.FC = () => {
  const initialValues: RegisterFormValues = { name: "", email: "", phone: "", password: "", repassword: "" };
  const companyCode = useSelector((state: RootState) => state.app.companyCode);
  const companyData = useSelector((state: RootState) => state.company.data);
  const dispatch = useAppDispatch();
  const [errorMessage, setErrorMessage] = React.useState("");
  const navigate = useNavigate();

  React.useEffect(() => {
    if (companyCode && !companyData) {
      dispatch(fetchCompany(companyCode));
    }
    // eslint-disable-next-line
  }, []);

  const handleSubmit = async (values: RegisterFormValues, actions: FormikHelpers<RegisterFormValues>) => {
    try {
      setErrorMessage("");
      if (values.password !== values.repassword) {
        setErrorMessage("As senhas não conferem");
        return;
      }
      actions.setSubmitting(true);
      await Api.post(`/user/register`, { ...values, company_code: companyCode });
      ReactGA.event({ action: "sign_up", category: "Login", label: "Usuário se cadastrou" });
      MetaPixel.trackCustom("sign_up", { category: "Login", label: "Usuário se cadastrou" });
      const { data } = await Api.post(`/user/login`, { username: values.email, password: values.password, company_code: companyCode });
      Auth.setAuthData(data.token, data.userName, data.userRole);
      LogRocket.identify(data.userId, {
        name: data.name,
        email: values.email,
      });
      navigate(`/`, { replace: true });
    } catch (error: any) {
      console.log(error, "error in register");
      actions.setSubmitting(false);
      if (error?.response?.data?.userMessage === "unauthorized") return setErrorMessage("Erro no cadastro, tente novamente.");
      setErrorMessage(error?.response?.data?.userMessage ?? "erro de conexão");
    }
  };

  if (Auth.isAuthenticated()) return <Navigate to="/" />;

  return (
    <RootContainer>
      <FormContainerWrapper>
        <div className={"text-center mb-3"}>
          <span>Cadastre-se e tenha mais facilidade na hora de comprar!</span>
        </div>
        <FormContainer>
          <Formik initialValues={initialValues} onSubmit={handleSubmit}>
            {({ isSubmitting }) => (
              <Form>
                <div className="mb-3">
                  <span>Nome completo</span>
                  <Field name="name" className="form-control" placeholder="Digite seu nome completo" required />
                </div>
                <div className="mb-3">
                  <span>Email</span>
                  <Field name="email" type="email" className="form-control" placeholder="Digite seu email" required />
                </div>
                <div className="mb-3">
                  <FormikTextInput
                    label="Telefone"
                    name="phone"
                    mask="(99)99999-9999"
                    placeholder="(__) _____-____"
                    required={companyData.requires_customer_phone_on_register}
                  />
                </div>
                <div className="mb-3">
                  <span>Senha</span>
                  <Field name="password" type="password" className="form-control" placeholder="Digite sua senha" required />
                </div>
                <div className="mb-3">
                  <span>Confirmar senha</span>
                  <Field name="repassword" type="password" className="form-control" placeholder="Confirme sua senha" required />
                </div>
                <ErrorMessage message={errorMessage} />
                <div className="w-100 d-grid mt-4">
                  <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                    entrar
                  </button>
                </div>
                <div className={"d-flex justify-content-center mt-4"}>
                  <Link to={`/login`}>já tenho conta</Link>
                </div>
              </Form>
            )}
          </Formik>
        </FormContainer>
      </FormContainerWrapper>
    </RootContainer>
  );
};

export default RegisterScreen;
